module.exports = (window.__MEEGO_GLOBAL__?.loadRemoteEntryContainer?.('@meego-remote/ipd') || new Promise(resolve => {
      const proxy = {
        get: async (request) => {
            const mod = await window['meego_remote_ipd'].get(request);
            const res = await mod();
            return () => res;
        },
        init: (arg) => {
          try {
            window['meego_remote_ipd'].init(arg);
          } catch(e) {
            console.log('remote container already initialized')
          }
        }
      };
      if (window['meego_remote_ipd']) {
        resolve(proxy);
        return;
      }
      const createScript = function(remoteUrl) {
        const script = document.createElement('script')
        script.src = remoteUrl;
        script.onload = () => {
          resolve(proxy)
        }
        document.head.appendChild(script);
      };
      if (__MEEGO_HOST_MANIFESTS_SSG__) {
        createScript(/^https/.test(__MEEGO_HOST_MANIFESTS_SSG__) ? __MEEGO_HOST_MANIFESTS_SSG__ : ('https:' + __MEEGO_HOST_MANIFESTS_SSG__));
      } else if ('') {
        fetch('').then(res => res.json()).then(res => {
          if (res?.remoteEntry?.url) {
            createScript('https:' + res.remoteEntry.url);
          } else {
            throw new Error('拉取内容异常')
          }
        });
      } else {
        fetch('/b/meego_project_fe/host/manifest').then(res => res.text()).then(res => {
          createScript('https:' + res);
        });
      }
    }))
    ;